import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class RaiseBugService {

  constructor(private rest : RestService) { }

  public fetchSuites(projectId :any){
    return this.rest.get('projectSuites',projectId);
  }

  public fetchFeature(projectId : any){
    return this.rest.get('projectFeatures', projectId);
  }

  public fetchScenario(projectId : any){
    return this.rest.get('projectScenarios', projectId);
  }

  public raiseBug(payload :any){
    return this.rest.post('createBug', payload);
  }

}